import { brandNameOrDefault, formatBRL, formatDateTimeBR, receiptLogoHtml } from './print-receipt.util';

export interface ComprovanteEstorno {
  nmPaciente: string;
  cpf: string;
  nrAdiantamento: number;
  valor: number;
  origem: string;
  estabelecimento: string;
  dataHora: string;
  usuario: string;
  logo: string;
  cdEmpresa: string;
  marca: string;
}

// Nada aqui pode se confundir com um comprovante de pagamento.
export function montarComprovanteEstorno(dados: ComprovanteEstorno): string {
  return `
    <div class="header">
      <div class="logo">${receiptLogoHtml(dados.logo, dados.cdEmpresa)}</div>
      <div style="text-align: right;">
        <p class="title">Comprovante de Estorno</p>
        <p class="subtitle">Estorno de pagamento avulso</p>
        <p class="receipt-number">Adiantamento Nº ${dados.nrAdiantamento}</p>
      </div>
    </div>
    <table class="data">
      <tr><td class="label">Paciente</td><td class="value">${dados.nmPaciente || '—'}</td></tr>
      <tr><td class="label">CPF</td><td class="value">${dados.cpf || '—'}</td></tr>
      <tr><td class="label">Estabelecimento</td><td class="value">${dados.estabelecimento || '—'}</td></tr>
      <tr><td class="label">Origem</td><td class="value">${dados.origem}</td></tr>
      <tr><td class="label">Data/Hora do estorno</td><td class="value">${formatDateTimeBR(dados.dataHora)}</td></tr>
      <tr><td class="label">Estornado por</td><td class="value">${dados.usuario}</td></tr>
    </table>
    <div class="valor-box">
      <div style="font-size: 10px; color: #626272;">Valor devolvido</div>
      <div class="amount">- ${formatBRL(dados.valor)}</div>
    </div>
    <div class="footer">${brandNameOrDefault(dados.marca)} — ESTORNO — Comprovante sem valor fiscal</div>
  `;
}
